import { useEffect } from "react";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import styles from "./AddFollowUp.module.css";
import { useAuth0 } from "@auth0/auth0-react";

const schema = yup.object().shape({
  date: yup.date().required("This field is Required"),
  description: yup.string().max(200, "Description cannot be more than 200 characters"),
});

const AddFollowUp = ({ setOpenFollowUpModal, setLoading, setSnackbarOpen, setSnackbarMsg, setAllData, followUpEditData, setFollowUpEditData, prospect_id }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { handleSubmit, control, errors, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      description: "",
    },
  });

  useEffect(() => {
    if (followUpEditData) {
      setValue("date", dayjs(followUpEditData?.date));
      setValue("description", followUpEditData?.description);
    }
  }, [followUpEditData, setValue]);

  const onSubmit = async (data) => {
    setLoading(true);
    setOpenFollowUpModal(false);

    data = { ...data };
    data.date = dayjs(data?.date).format("YYYY-MM-DD");
    data["prospect_id"] = prospect_id;
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    return axios
      .post(process.env.REACT_APP_APPLICANT_API_URL + "v1/follow-ups", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setSnackbarOpen(true);
        setSnackbarMsg("Follow-Up added successfully!");

        setLoading(false);

        setAllData((prev) => {
          return [response.data.data, ...prev];
        });
      })
      .catch((error) => {
        if (typeof error.response !== "undefined") {
          setSnackbarOpen(true);
          setSnackbarMsg(error.response.data.message);
          setLoading(false);
        }
      });
  };

  const onUpdate = async (data) => {
    setLoading(true);
    setOpenFollowUpModal(false);

    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });
    data = { ...data };
    data.date = dayjs(data?.date).format("YYYY-MM-DD");
    data["prospect_id"] = prospect_id;

    return axios
      .post(
        process.env.REACT_APP_APPLICANT_API_URL +
        "v1/follow-ups/" +
        followUpEditData?.id,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setSnackbarOpen(true);
        setSnackbarMsg("Follow-Up updated successfully.");

        setLoading(false);
        setFollowUpEditData(null);
        setAllData((prev) => {
          return prev?.map((item) => {
            if (item.id === followUpEditData?.id) return response.data.data;
            return item;
          });
        });
      })
      .catch((error) => {
        if (typeof error.response !== "undefined") {
          setSnackbarOpen(true);
          setSnackbarMsg(error.response.data.message);
          setLoading(false);
        }
      });
  };
  return (
    <div className={`${styles.ProfileCardEditSec}`}>
      <form onSubmit={handleSubmit(followUpEditData ? onUpdate : onSubmit)}>
        <div className={`${styles.AddFollowUpForm}`}>
          <div className={`${styles.EditFormHalfSec} FormGroup`}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Controller
                name="date"
                control={control}
                render={(field) => (
                  <DatePicker
                    {...field}
                    label="Choose Date*"
                    renderInput={(params) => <TextField {...params} />}
                  />
                )}
              />
            </LocalizationProvider>
            {errors.date && (
              <p className={`${styles.ErrorM}`}>{errors?.date?.message}</p>
            )}
          </div>
          {/* <div className={`${styles.EditFormHalfSec} FormGroup`}>
            <ChooseTimePicker />
          </div> */}
          <div className={`${styles.EditFormFullSec} FormGroup`}>
            <Controller
              name={`description`}
              control={control}
              render={(field) => (
                <TextField
                  onChange={(e) => field.onChange(e)}
                  id="outlined-basic"
                  label="Add a Note"
                  variant="outlined"
                  value={field.value}
                />
              )}
            />
            {errors.description && (
              <p className={`${styles.ErrorM}`}>
                {errors?.description?.message}
              </p>
            )}
          </div>
        </div>
        <div className={`${styles.ButtonArea}`}>
          <button
            className={`${styles.ButtonVoiletLine}`}
            type="button"
            onClick={(e) => setOpenFollowUpModal(false)}
          >
            Cancel
          </button>
          <button className={`${styles.ButtonVoiletSolid}`} type="submit">
            {followUpEditData ? "Update" : "Add"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddFollowUp;
